export default "__VITE_ASSET__CU1Jd5Yi__"